module.exports = __webpack_public_path__ + "img/sz.8263681b.svg";